/* global axios */
import BotifyAPI from 'dashboard/api/BotifyAPI';

class BotifySandbox extends BotifyAPI {
  constructor() {
    super('sandbox', { accountScoped: false });
  }

  createSession(botifyId) {
    return (
      this.ensureConfigured() ||
      axios.post(`${this.url}/botify/${botifyId}/session`)
    );
  }

  sendMessage(sessionId, message) {
    return (
      this.ensureConfigured() ||
      axios.post(`${this.url}/session/${sessionId}/message`, message)
    );
  }
}

export default new BotifySandbox();
